import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

import { getLoanDurationInMonths } from '../../../../myOffers/MyOffers.helpers';

export function formatDurations(
    offers: TFormalOffer[],
    locale: 'en-EN' | 'de-DE'
) {
    const offerDurations = offers.map((offer) =>
        getLoanDurationInMonths(offer.duration!)
    );

    if (!offerDurations.length) return null;

    const formatter = new Intl.ListFormat(locale, {
        style: 'short',
        type: 'disjunction'
    });

    const months = offerDurations.map((d) => d.toString());
    return formatter.format(months);
}
